// extracted by mini-css-extract-plugin
module.exports = {"alGhadeerPageWrapper":"style_alGhadeerPageWrapper__N6IHp","alGhadeerCommingSoon":"style_alGhadeerCommingSoon__5lkMQ"};